import {PureComponent} from 'react';
import {connect} from 'react-redux';

import BrandListPage from "./BrandListPage.component";
import {MetaDispatcher} from "../BrandPage/BrandPage.container";


const BrandListDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    '../../store/BrandList/BrandList.dispatcher'
    );
const BreadcrumbsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Breadcrumbs/Breadcrumbs.dispatcher'
    );

/** @namespace Route/BrandListPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    brandList: state.BrandListReducer.brandList,
    brand_type_options: state.BrandListReducer.brand_type_options,
    device: state.ConfigReducer.device,
    imagePlaceholder: state.ConfigReducer.brand_small_placeholder,
    brand_attributes: state.ConfigReducer.brand_attributes ? state.ConfigReducer.brand_attributes.split(',') : [],
    isFashion: state.switchWebsiteReducer.isFashion
});


/** @namespace Route/BrandListPage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateMetaFromBrand: (brand) => MetaDispatcher.then(
        ({ default: dispatcher }) => dispatcher.updateWithCategory(brand, dispatch)
    ),
    updateBreadcrumbs: (breadcrumbs) => ((Object.keys(breadcrumbs).length)
            ? BreadcrumbsDispatcher.then(
                ({default: dispatcher}) => dispatcher.update(breadcrumbs, dispatch)
            )
            : BreadcrumbsDispatcher.then(
                ({default: dispatcher}) => dispatcher.update([], dispatch)
            )
    ),
    clearState: () => BrandListDispatcher.then(
        ({default: dispatcher}) => dispatcher.clearBrandReduxState(dispatch)
    ),
    prepareRequest: (options) => BrandListDispatcher.then(
        ({default: dispatcher}) => dispatcher.handleData(dispatch, options)
    )});


/** @namespace Route/BrandListPage/Container **/
export class BrandListPageContainer extends PureComponent {
    state = {
        featuredBrands: [],
        filteredBrandsList: [],
        selectedMenuIndex : null
    }

    componentDidMount() {
        setTimeout(()=> {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 500);
        this._requestBrandList();
        this.updateMeta();
        this._updateBreadcrumbs();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { featuredBrands, selectedMenuIndex, filteredBrandsList } = this.state;
        const {  selectedMenuIndex : prevSelectedMenuIndex, filteredBrandsList : prevFilteredBrandsList  } = prevState;
        const { brandList, isFashion } = this.props;

        if (featuredBrands.length === 0 && brandList && Object.keys(brandList).length !== 0) {
            let allFeaturedBrands = [];
            Object.entries(brandList).map(([key, item]) => {
                if (item.is_featured === "1") {
                    allFeaturedBrands.push(item);
                }
            });

            if(allFeaturedBrands.length){
                this.setState({
                    featuredBrands: allFeaturedBrands
                })
            }
        }

        if ( brandList && Object.keys(brandList).length !== 0 && (prevSelectedMenuIndex != selectedMenuIndex || selectedMenuIndex === null )) {
            if(selectedMenuIndex === null){
                selectedMenuIndex = isFashion ? 1 : 0;
                this.setState({selectedMenuIndex: isFashion ? 1 :0});
            }
            let filteredBrandsList = [];
            Object.entries(brandList).map(([key, item]) => {
               if(selectedMenuIndex == 2){
                   filteredBrandsList.push(item)
               }else if(item.brand_type && item.brand_type.split(',').includes(selectedMenuIndex.toString())){
                   filteredBrandsList.push(item)
               }
            })

            if(JSON.stringify(filteredBrandsList) !== JSON.stringify(prevFilteredBrandsList)){
                this.setState({
                    filteredBrandsList: filteredBrandsList
                })
            }
        }
    }

    componentWillUnmount() {
        const { clearState } = this.props;
        clearState()
    }

    containerFunctions = {
        onTabClick: this.onTabClick.bind(this)
    }

    onTabClick(tabId){
        this.setState({selectedMenuIndex : tabId});
    }

    camalize(str) {
        return  (" " + str).toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function(match, chr)
        {
            return chr.toUpperCase().replace('_',' ');
        });
    }

    updateMeta() {
        const {
            updateMetaFromBrand,
            attribute_code,
            canonical_url,
            redirect_code_previous,
            meta_title,
            meta_description,
            description
        } = this.props;

        updateMetaFromBrand({
            meta_title : meta_title,
            canonical_url,
            redirect_code_previous,
            redirect_from: window.location.pathname,
            meta_description,
            description

        });
    }

    _updateBreadcrumbs() {
        const {
            attribute_code,
            canonical_url,
            updateBreadcrumbs
        } = this.props;
        updateBreadcrumbs(
            [
                {
                    url: '/' + attribute_code,
                    name: attribute_code === 'brand' ? __('BRANDS') : this.camalize(attribute_code)
                }
                ]
        );
    }

    _requestBrandList() {
        const {prepareRequest} = this.props;
        prepareRequest(this.props.attribute_code);
    }

    render() {
        return (
            <BrandListPage
                {...this.state}
                {...this.props}
                {...this.containerFunctions}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BrandListPageContainer);
